// ASIS mobile shell bridge. Native side injects window.asisMobile at runtime;
// this file only describes the contract the web client consumes. Backend is
// fixed (app.asisdot.com) — no permission is requested by mere detection.
import type { SessionUser } from '../session/controller.js';
import type { BluetoothAdapter } from '../device-ble/transport.js';

export interface AsisMobileBridge {
  readonly platform: 'ios' | 'android';
  readonly capabilities: {
    readonly bluetooth: true;
    readonly secureSession: true;
  };
  readonly bluetooth: BluetoothAdapter;
  /** Cancel native discovery/selection; callers invalidate their attempt first. */
  cancelBluetooth?(): Promise<void>;
  getConfig(): Promise<{ serverUrl: string }>;
  getSession(): Promise<{ token: string; user: SessionUser } | null>;
  saveSession(payload: { token: string; user: SessionUser; expiresAt?: string }): Promise<unknown>;
  clearSession(): Promise<unknown>;
  getVersion(): Promise<string>;
  onAppStateChange(listener: (active: boolean) => void): () => void;
}

export const ASIS_MOBILE_SERVER_BASE = 'https://app.asisdot.com' as const;

declare global {
  interface Window {
    asisMobile?: AsisMobileBridge;
  }
}

export function getMobileBridge(): AsisMobileBridge | null {
  if (typeof window === 'undefined') return null;
  return window.asisMobile ?? null;
}
